import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Breadcrumb.js");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/src/common/components/Loading/LoadingProducts.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/src/components/CategoryDescription/CategoryDescription.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/src/components/Breadcrumb/Breadcrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/src/components/ProductList/ProductsAndConfiguratorsList.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-valcea/_work/pefoc-hydra/pefoc-hydra/src/components/ReadMore/ReadMore.tsx");
